import packageJson from '../../package.json';

export function Footer() {
  return (
    <footer className="mt-auto px-6 py-4">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3">
        <span className="text-xs font-medium text-gray-400">הצעות מחיר אלקה</span>
        <span className="h-1 w-1 rounded-full bg-gray-300" />
        <span className="rounded-full border border-gray-200 bg-white/70 px-2 py-0.5 font-mono text-xs text-gray-400">
          v{packageJson.version}
        </span>
      </div>
    </footer>
  );
}
